function getDisabledSelectedTextColor({
  theme,
  selected = false,
  disabled = false
}) {
  if (disabled) {
    return theme.palette.text.disabled;
  }

  if (selected) {
    return 'inherit';
  }

  return theme.palette.secondary.main;
}

export default getDisabledSelectedTextColor;
